<template>
  <v-dialog v-model="dialog" width="600">
    <template v-slot:activator="{ on, attrs }">
      <i-btn
        class="btn-type-02 mr-2"
        v-bind="attrs"
        v-on="on"
        @click.stop="init"
      >
        회원탈퇴
      </i-btn>
    </template>
    <v-card class="modal-pop modal-type-01">
      <v-card-title class="modal-title">
        {{ $t('회원탈퇴') }}
      </v-card-title>
      <vue-custom-scrollbar class="modal-scroll">
        <v-card-text class="modal-contents">
          <v-row class="ma-0">
            <v-col class="pa-0">
              <ul class="pl-0">
                <li class="thanks">
                  {{ $t('그동안 함께 해주셔서 감사합니다.') }}
                </li>
                <li class="guide-01">
                  {{
                    $t(
                      '회원 탈퇴 시 다시 로그인 하실 수 없으며 탈퇴 후 6개월간 재가입하실 수 없습니다.',
                    )
                  }}
                </li>
                <li class="guide-01">
                  {{
                    $t(
                      '회원 탈퇴 시 재가입 방지를 위해 6개월간 개인정보 및 활동내역(이력서 Q&A)이 보관되며 6개월 이후 모든 정보가 삭제됩니다.',
                    )
                  }}
                </li>
              </ul>
              <v-row
                class="mx-0 mt-5 mb-7"
                align="center"
                justify="space-between"
              >
                <v-col cols="auto" class="pa-0">
                  <i-checkbox
                    hide-details
                    dense
                    :label="name + this.$t('의 회원정보 확인')"
                    class="icon-checkbox mt-0 pt-0"
                    v-model="isDrop"
                  ></i-checkbox>
                </v-col>
                <v-col cols="auto" class="pa-0">
                  <span
                    class="withdrawal-status "
                    v-for="(item, i) in counter"
                    :class="{ 'mr-2 pr-2': i == 0 }"
                    :key="item.name"
                    >{{ $t(item.name) }} {{ item.count }} {{ $t('건') }}</span
                  >
                </v-col>
              </v-row>
              <v-form ref="form">
                <v-row class="ma-0 mb-2">
                  <i-text-field
                    :append-icon="show1 ? mdiEye : mdiEyeOff"
                    v-model="password"
                    :rules="[rules.required]"
                    :type="show1 ? 'text' : 'password'"
                    label="비밀번호 입력"
                    outlined
                    hide-details
                    dense
                    class="box-type-01"
                    @click:append="show1 = !show1"
                  ></i-text-field>
                </v-row>
              </v-form>
            </v-col>
          </v-row>
        </v-card-text>
      </vue-custom-scrollbar>
      <v-card-actions class="modal-btn">
        <i-btn class="btn-type-01" @click="dialog = false">
          닫기
        </i-btn>
        <i-btn class="btn-type-02" v-show="isDrop" @click="drop">
          저장
        </i-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { LoadingMixin } from '@/mixin/loading.js';
import { DialogMixin } from '@/mixin/dialog.js';

import { postAuthJson } from '@/api/network';

import { mdiEye, mdiEyeOff } from '@mdi/js';

import vueCustomScrollbar from 'vue-custom-scrollbar';
import 'vue-custom-scrollbar/dist/vueScrollbar.css';

export default {
  components: { vueCustomScrollbar },
  mixins: [DialogMixin, LoadingMixin],
  props: {
    routeParam: Object,
    counter: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      mdiEye,
      mdiEyeOff,
      name: '',
      email: '',
      apply: 0,
      qna: 0,
      password: '',
      isDrop: false,
      show1: false,
      dialog: false,
      rules: {
        required: value => !!value || 'Required.',
      },
    };
  },
  methods: {
    init() {
      if (this.$refs.form) this.$refs.form.resetValidation();
      this.name = this.$attrs.name;
      this.email = this.$attrs.email;
      this.apply = this.$attrs.apply;
      this.qna = this.$attrs.qna;
    },
    drop() {
      if (this.isDrop && this.$refs.form && this.$refs.form.validate()) {
        this.showLoading();
        const p = {
          loginId: this.email,
          password: this.password,
        };

        postAuthJson('api/v1/' + this.$route.params.tenantKey + '/drop/user', p)
          .then(res => {
            if (res.data != null && res.data.hasOwnProperty('status')) {
              var v = { message: res.data.message };
              if (res.data.status === 'success') {
                this.hideLoading();
                this.$showAlert(v);
                this.$store.commit('logout');
                this.$router.push('/login/' + this.$route.params.tenantKey);
              } else {
                this.$showAlert(v);
              }
            }
          })
          .catch(error => {
            console.log(error.response);
          });
      }
    },
  },
};
</script>
